import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PageUpdateService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchPageUpdate = createAsyncThunk(
    'pageUpdate/fetchPageUpdate',
    async ({ id, Slug, Title, Description, FormID }) => {
        const response = await PageUpdateService(id, Title, Slug, Description, FormID);
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const pageUpdateSlice = createSlice({
    name: 'pageUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPageUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchPageUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchPageUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default pageUpdateSlice.reducer;
